import type { FieldPack } from '../../../../core/fields/types';
import { FieldType } from '../../../../core/fields/types';

export const orgchartSkillsFieldPack: FieldPack = {
  id: 'orgchart-skills',
  name: 'Skills & Capabilities',
  description: 'Skills, certifications, and education for team assembly and role requirement design',
  version: '1.0.0',
  dependencies: ['orgchart-base'],
  fields: [
    {
      id: 'skills',
      label: 'Skills',
      type: FieldType.MULTI_SELECT,
      tags: ['skills'],
      priority: 90,
      namespace: 'skills',
      allowCustomOptions: true,
      sensitivity: 'internal',
      readonly: true,
      sourceTypes: ['skill_assertion'],
      metadata: { projectionOwned: true, legacyScalar: true },
    },
    {
      id: 'primarySkill',
      label: 'Primary Skill',
      type: FieldType.SELECT,
      allowCustomOptions: true,
      tags: ['skills'],
      priority: 85,
      namespace: 'skills',
      sensitivity: 'internal',
      readonly: true,
      sourceTypes: ['skill_assertion'],
      metadata: { projectionOwned: true, legacyScalar: true },
    },
    {
      id: 'certifications',
      label: 'Certifications',
      type: FieldType.MULTI_SELECT,
      tags: ['skills', 'compliance'],
      priority: 80,
      namespace: 'skills',
      allowCustomOptions: true,
      sensitivity: 'internal',
      readonly: true,
      sourceTypes: ['credential_assertion'],
      metadata: { projectionOwned: true, legacyScalar: true },
    },
    {
      id: 'languages',
      label: 'Languages',
      type: FieldType.MULTI_SELECT,
      tags: ['skills'],
      priority: 75,
      namespace: 'skills',
      allowCustomOptions: true,
      sensitivity: 'internal',
      readonly: true,
      sourceTypes: ['skill_assertion'],
      metadata: { projectionOwned: true, legacyScalar: true },
    },
    {
      id: 'educationLevel',
      label: 'Education Level',
      type: FieldType.SELECT,
      tags: ['skills', 'education'],
      priority: 70,
      namespace: 'skills',
      options: [
        { value: 'high_school', label: 'High School' },
        { value: 'associate', label: 'Associate Degree' },
        { value: 'bachelor', label: "Bachelor's Degree" },
        { value: 'master', label: "Master's Degree" },
        { value: 'doctorate', label: 'Doctorate' },
        { value: 'professional', label: 'Professional Degree' },
      ],
      sensitivity: 'internal',
      readonly: true,
      sourceTypes: ['skill_assertion'],
      metadata: { projectionOwned: true, legacyScalar: true },
    },
    {
      id: 'educationField',
      label: 'Field of Study',
      type: FieldType.SELECT,
      allowCustomOptions: true,
      tags: ['skills', 'education'],
      priority: 65,
      namespace: 'skills',
      sensitivity: 'internal',
      readonly: true,
      sourceTypes: ['skill_assertion'],
      metadata: { projectionOwned: true, legacyScalar: true },
    },
    {
      id: 'competencies',
      label: 'Competencies',
      type: FieldType.MULTI_SELECT,
      tags: ['skills', 'competency'],
      priority: 55,
      namespace: 'skills',
      allowCustomOptions: true,
      sensitivity: 'internal',
      readonly: true,
      sourceTypes: ['skill_assertion'],
      metadata: { projectionOwned: true, legacyScalar: true },
    },
    {
      id: 'technicalSkills',
      label: 'Technical Skills',
      type: FieldType.MULTI_SELECT,
      tags: ['skills'],
      priority: 50,
      namespace: 'skills',
      allowCustomOptions: true,
      sensitivity: 'internal',
      readonly: true,
      sourceTypes: ['skill_assertion'],
      metadata: { projectionOwned: true, legacyScalar: true },
    },
    {
      id: 'leadershipSkills',
      label: 'Leadership Skills',
      type: FieldType.MULTI_SELECT,
      tags: ['skills'],
      priority: 45,
      namespace: 'skills',
      allowCustomOptions: true,
      sensitivity: 'internal',
      readonly: true,
      sourceTypes: ['skill_assertion'],
      metadata: { projectionOwned: true, legacyScalar: true },
    },
    {
      id: 'trainingCompleted',
      label: 'Training Completed',
      type: FieldType.MULTI_SELECT,
      tags: ['skills', 'development'],
      priority: 40,
      namespace: 'skills',
      allowCustomOptions: true,
      sensitivity: 'internal',
      readonly: true,
      sourceTypes: ['skill_assertion'],
      metadata: { projectionOwned: true, legacyScalar: true },
    },
    {
      id: 'certExpiryDate',
      label: 'Certification Expiry',
      type: FieldType.DATE,
      tags: ['skills', 'compliance'],
      priority: 35,
      namespace: 'skills',
      sensitivity: 'internal',
      readonly: true,
      sourceTypes: ['credential_assertion'],
      metadata: { projectionOwned: true, legacyScalar: true },
    },
  ],
};
